import * as Types from './types';
import { actionTypes } from './constants';

export const setData = (data: Partial<Types.ILoginHistoryState>): Types.ISetDataAction => ({
    type: actionTypes.SET_DATA,
    payload: data
});

export const updateHistory = (data: Types.IUpdateHistoryPayload): Types.IUpdateHistoryAction => ({
    type: actionTypes.UPDATE_HISTORY,
    payload: data
});

export const loadNextPage = (): Types.ILoadNextPageAction => ({
    type: actionTypes.LOAD_NEXT_PAGE
});
